export default __webpack_public_path__ + "static/media/port3.2b9a81ad.jfif";